exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input__inner{border-radius:1px}", ""]);

// exports
